import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import MicIcon from '../../../images/vector/mic.svg';

const RecordingStatusVisualizer = ({ recording }) => (
    <div className={classNames('recording-status-visualizer', { recording })}>
        <MicIcon />
        <span className="rec-text">REC</span>
    </div>
);

RecordingStatusVisualizer.propTypes = {
    recording: PropTypes.bool,
};

RecordingStatusVisualizer.defaultProps = {
    recording: false,
};

export default RecordingStatusVisualizer;
